import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './ObjectForm.css';

const ImageModal = ({ selectedImage, selectedImageIndex, totalImages, onClose, onPrevImage, onNextImage }) => {
  if (!selectedImage) return null;

  return (
    <div
      className="image-modal-overlay"
      onClick={onClose}
    >
      <div
        className="image-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={selectedImage}
          alt="Full size"
          className="modal-image"
        />
        <button
          className="modal-close-button"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        
        <button
          className={`modal-arrow-button modal-left-arrow ${selectedImageIndex <= 0 ? 'disabled' : ''}`}
          onClick={onPrevImage}
          disabled={selectedImageIndex <= 0}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>
        
        <button
          className={`modal-arrow-button modal-right-arrow ${selectedImageIndex >= totalImages - 1 ? 'disabled' : ''}`}
          onClick={onNextImage}
          disabled={selectedImageIndex >= totalImages - 1}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
        
        <div className="modal-image-counter">
          {selectedImageIndex + 1} / {totalImages}
        </div>
      </div>
    </div>
  );
};

export default ImageModal; 